import React from "react";
import "./investment.css";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import BannerComponent from "../../components/bannerComponent/bannerComponent";
import ButtonLinkComponent from "../../components/buttonLink/buttonLink";

const Investment = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=INVESTMENT";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("UNLOCK_GROWTH"),
    text: t("INV_SUB_HERO"),
    className: "investmentHeroBanner",
    chipText: t("INV_CHIP_HERO"),
  };

  const investmentOpportunities = [
    {
      title: t("GROWING_ECONOMY"),
      description: t("GROWING_ECONOMY_DESC"),
      image: "/img/photorealistic-money-with-plant 1.jpg",
    },
    {
      title: t("STRATEGIC_LOCATION"),
      description: t("STRATEGIC_LOCATION_DESC"),
      image:
        "/img/landscape-with-palm-trees-foreground-mountains-background 1.jpg",
    },
    {
      title: t("BUSINESS_FRIENDLY_ENVIRONMENT"),
      description: t("BUSINESS_FRIENDLY_ENVIRONMENT_DESC"),
      image: "/img/openart-image_8EdwNsOe_1715969282870_raw 1.jpg",
    },
  ];

  const keyInvestmentOpportunities = [
    {
      title: t("TECHNOLOGY_INNOVATION"),
      description: t("TECHNOLOGY_INNOVATION_DESC"),
      image: "/img/openart-image_xnWFVV2s_1715977952466_raw 1.jpg",
    },
    {
      title: t("RENEWABLE_ENERGY"),
      description: t("RENEWABLE_ENERGY_DESC"),
      image:
        "/img/solar-panels-wind-mills-sunset-sustainable-energy-eco-environment 1.jpg",
    },
    {
      title: t("TOURISM_HOSPITALITY"),
      description: t("TOURISM_HOSPITALITY_DESC"),
      image: "/img/openart-image_mcqC1H1z_1715979129937_raw 1.jpg",
    },
    {
      title: t("AGRIBUSINESS"),
      description: t("AGRIBUSINESS_DESC"),
      image: "/img/openart-image_pWRsLJZV_1715979441349_raw 1.jpg",
    },
    {
      title: t("REAL_ESTATE"),
      description: t("REAL_ESTATE_DESC"),
      image: "/img/openart-image_uMm4VzLw_1715979701510_raw 1.jpg",
    },
  ];

  const investmentStrategies = [
    {
      title: t("RESEARCH"),
      description: t("RESEARCH_DESC"),
      image:
        "/img/young-businesswoman-searches-data-with-magnifying-glass-generated-by-ai 1.jpg",
    },
    {
      title: t("LOCAL_PARTNERSHIPS"),
      description: t("LOCAL_PARTNERSHIPS_DESC"),
      image: "/img/openart-image_S2epkhXs_1715980233291_raw 1.jpg",
    },
    {
      title: t("DIVERSIFICATION"),
      description: t("DIVERSIFICATION_DESC"),
      image: "/img/openart-image_3rgtA7wH_1715980748015_raw 1.jpg",
    },
  ];

  function OpportunityCard({ image, title, description }) {
    return (
      <article className="investmentOpportunityCard">
        <div className="investmentOpportunityMedia">
          <img src={image} alt={title} />
        </div>
        <div className="investmentOpportunityContent">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </article>
    );
  }

  function SectorCard({ image, title, description }) {
    return (
      <article className="investmentSectorCard">
          <img src={image} alt={title} className="investmentSectorImage"/>
        
        <div className="investmentSectorOverlay">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </article>
    );
  }

  function HelpCard({ image, title, description }) {
    return (
      <article className="investmentHelpCard">
        <div className="investmentHelpMedia">
          <img src={image} alt={title} />
        </div>
        <div className="investmentHelpContent">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="investmentPage">
        <section className="investmentHero investmentHeroFull">
          <div className="investmentHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("FINANCIALS_MAIN_BANNER_BUTTON")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="investmentWhy">
          <div className="investmentWhyWrap">
            <div className="investmentSectionIntro">
              <h2>{t("WHY_INVEST_COLOMBIA")}</h2>
              <p>
                {t("INVESTMENT_WHY_INTRO")}
              </p>
            </div>

            <div className="investmentOpportunityGrid">
              {investmentOpportunities.map((item, index) => (
                <OpportunityCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="investmentSectors">
          <div className="investmentSectorsWrap">
            <div className="investmentSectionIntro">
              <h2>{t("KEY_INVESTMENT_SECTORS")}</h2>
              <p>
                {t("INVESTMENT_SECTORS_INTRO")}
              </p>
            </div>

            <div className="investmentSectorsGrid">
              {keyInvestmentOpportunities.map((item, index) => (
                <SectorCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="investmentHelp">
          <div className="investmentSectionIntro">
            <h2>{t("HOW_WE_CAN_HELP")}</h2>
            <p>{t("HELP_TEXT")}</p>
          </div>

          <div className="investmentHelpGrid">
            {investmentStrategies.map((item, index) => (
              <HelpCard
                key={index}
                title={item.title}
                description={item.description}
                image={item.image}
              />
            ))}
          </div>
        </section>

        <section className="investmentCta">
          <div className="investmentCtaInner">
            <div className="investmentCtaContent">
              <h2>{t("GET_STARTED_TEXT")}</h2>
              <div className="investmentCtaText">
                <p>{t("GET_STARTED_CONTACT")}</p>
              </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("FINANCIALS_MAIN_BANNER_BUTTON")}
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=INVESTMENT"
              }
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Investment;